import React, { useState } from "react";

import { FormattedMessage } from "react-intl";

import TimeframeControl from "src/organization/pages/project/environment/metrics/components/timeframeControl/TimeframeControl";
import useActivityToggle from "src/organization/pages/project/environment/metrics/hooks/useActivityToggle";
import useInitialTimeframe from "src/organization/pages/project/environment/metrics/hooks/useInitialTimeframe";
import useLoadAutoScale from "src/organization/pages/project/environment/metrics/hooks/useLoadAutoScale";
import { MetricsContext } from "src/organization/pages/project/environment/metrics/hooks/useMetricsContext";
import usePinnedTabsSync from "src/organization/pages/project/environment/metrics/hooks/usePinnedTabsSync";
import useStickyTimecontrol from "src/organization/pages/project/environment/metrics/hooks/useStickyTimecontrol";
import { useInternalStorageServices } from "src/organization/pages/project/environment/metrics/resources/grid/util";
import * as V from "src/organization/pages/project/environment/metrics/resources/views.styles";
import usePollgroup, {
  PollgroupContext
} from "src/organization/pages/project/environment/metrics/utils/polling/usePollgroup";
import { getPollInterval } from "src/organization/pages/project/environment/metrics/utils/polling/utils";

import UsageView from "../totalUsage/Page2";

import * as S from "./Grid.styles";
import ServiceGroup from "./ServiceGroup";

const Page = () => {
  useLoadAutoScale();
  const [isDeployment, setDeployment] = useActivityToggle();
  const [timeFrame, setTimeFrame] = useState(useInitialTimeframe());

  const pollInterval = getPollInterval(timeFrame);

  const { pollgroup, cycle, status } = usePollgroup({
    timeFrame
  });

  const { onSyncChange, isSynced, canJoinSync } = usePinnedTabsSync({
    setTimeFrame: setTimeFrame,
    timeFrame: timeFrame
  });

  const handleSyncChange = (isSynced: boolean) => {
    onSyncChange(isSynced, timeFrame);
  };

  const serviceCategories = useInternalStorageServices();
  const stickyRef = useStickyTimecontrol();

  return (
    <MetricsContext.Provider
      value={{
        isDeployment,
        timeFrame,
        setTimeFrame
      }}
    >
      <PollgroupContext.Provider value={{ pollgroup }}>
        <V.Header ref={stickyRef}>
          <V.Heading tag="h2">
            <FormattedMessage id="metrics.grid.heading" />
          </V.Heading>
          <TimeframeControl
            timeframe={{
              onChange: setTimeFrame,
              timeframe: timeFrame
            }}
            isUpdating={status.isLoading}
            pollInterval={pollInterval}
            lastUpdated={cycle.lastUpdated}
            deployment={{ enabled: isDeployment, onChange: setDeployment }}
            tabSync={{
              onSyncChange: handleSyncChange,
              isSynced,
              canJoinSync
            }}
          />
        </V.Header>

        <S.Layout>
          <UsageView />
          {serviceCategories.map((services, i) => (
            <ServiceGroup key={i} onBrush={setTimeFrame} services={services} />
          ))}
        </S.Layout>
      </PollgroupContext.Provider>
    </MetricsContext.Provider>
  );
};

export default Page;
